import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'cream-light' | 'cream' | 'cream-dark' | 'white' | 'olive' | 'olive-deep';
}
export function Section({
  children,
  className = '',
  id,
  bg = 'cream-light'
}: SectionProps) {
  const bgColors = {
    'cream-light': 'bg-cream-light',
    cream: 'bg-cream',
    'cream-dark': 'bg-cream-dark',
    white: 'bg-white',
    olive: 'bg-olive text-cream-light',
    'olive-deep': 'bg-olive-deep text-cream-light'
  };
  return <section id={id} className={`py-12 md:py-32 overflow-hidden ${bgColors[bg]} ${className} bg-noise`} data-id="element-486">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-7xl mx-auto px-6 md:px-8 relative z-10" data-id="element-487">
        {children}
      </motion.div>
    </section>;
}